<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 class="changelog">
        <v-tabs fixed-tabs v-model="tab">
          <v-tab key="changelog" ripple>
            <v-btn large icon @click="light = !light">
              <v-icon large :color="light ? 'amber' : 'black'">
                {{light ? 'mdi-lightbulb-on' : 'mdi-lightbulb'}}
              </v-icon>
            </v-btn>
            Changelog
          </v-tab>
          <v-tab key="stats" ripple>
            Stats
          </v-tab>

          <v-tab-item key="changelog">
            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Mai-14</span>
              <span style="color: var(--v-info-darken1)">Feature - Offline photos</span>
              <v-icon color="success">mdi-check</v-icon>
            </h3>
            <p>
              La incarcarea de poze, aplicatia salveaza o referinta locala a acestora.
              Asta inseamna ca aplicatia nu "uita" pozele atasate nici daca se inchide telefonul.
              Utilizatorul porneste manual upload-ul.
              Utilizatorul poate opri momentan upload-ul (actiunea intra efectiv in vigoare dupa ce se termina upload-ul pozei curente).
              Aplicatia detecteaza lipsa conexiunii la Internet si nu permite actionarea butonului de pornire upload (acest lucru este realizat printr-un joc de ping-pong pe care aplicatia il face cu serverul la fiecare 60 de secunde).
              Aplicatia semnaleaza conexiuni de tip lie-fi (viteza foarte mica) <strong>dar nu poate detecta viteze relativ mici</strong> (posibil de implementat pentru Android, feature lipsa pe iOS).
              Bara de progres se actualizeaza doar dupa upload-ul reusit al unei poze (upload pe chunks planificat).

              <img :src="`${url}/img/upload.png`" width="90%" style="max-width: 300px; display: block">
              <img :src="`${url}/img/lie-fi.png`" width="90%" style="max-width: 300px; display: block">
            </p>
            <p>
              <strong>Scenariu posibil</strong>: se fac poze, se incarca in aplicatie si se face upload-ul abia cand exista semnal puternic sau conexiune wi-fi.
            </p>
            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Mai-14</span>
              <span style="color: var(--v-primary-base)">User - Delete poze</span>
            </h3>
            <p>
              Oirice <em>user</em> poate sterge poze atata timp cat au fost incarcate de el si nu au trecut 10 minute.
              Neindeplinirea conditiilor duce la <strong>silent fail</strong>.
            </p>
            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Mai-14</span>
              <span style="color: var(--v-primary-base)">User - Delete poze</span>
            </h3>
            <p>
              Oirice <em>user</em> vede in UI optiunea de stergere poze, indiferent de conditii.
              <br>
              <img :src="`${url}/img/delete-photo-ui.png`" height="36">
            </p>
            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Mai-14</span>
              <span style="color: var(--v-primary-base)">Desktop - Tooltip butoane</span>
            </h3>
            <p>
              Fiecare buton are tooltip explicativ la mouseover. Valabil doar pe desktop.
            </p>
            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Mai-14</span>
              <span style="color: var(--v-primary-base)">Admin - Evidentiere simbol harta</span>
            </h3>
            <p>
              La navigarea din lista de Simboluri catre un simbol pe harta, acel simbol primeste o animatie bounce.
              <br>
              <img :src="`${url}/img/bounce.gif`" height="64">
            </p>
            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Mai-14</span>
              <span style="color: var(--v-info-darken1)">Fix - Filtre + Search</span>
            </h3>
            <p>
              Filtrele functioneaza si in combinatie cu campul de cautare.
            </p>
            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Mai-13</span>
              <span style="color: var(--v-primary-base)">Admin - Export XLSX</span>
            </h3>
            <p>
              2 butoane pentru exportul informatiilor in format xlsx pe baza unui template predefinit.
              Se esxclude centrul geometric (coloanele nu se populeaza dar raman).
              Se adauga coloana "nr poze".
            </p>
            <p>
              Un buton exporta toate informatiile, ignorand filtere, eticheta si paginatia. Poate fi considerat un export al bazei de date (minus centru geografic)
              <img :src="`${url}/img/download-xlsx-all.png`" height="14">
            </p>
            <p>
              Un buton exporta tinand cont de filtre, etichete si paginatie.
              <img :src="`${url}/img/download-xlsx-filters.png`" height="14">
            </p>
            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Mai-13</span>
              <span style="color: var(--v-primary-base)">Admin - Import XLSX eticheta</span>
            </h3>
            <p>
              La import se specifica o eticheta pentru simbolurile incarcate. Eticheta devine parte a filtrelor.
            </p>
            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Mai-13</span>
              <span style="color: var(--v-primary-base)">User - Filtru eticheta</span>
            </h3>
            <p>
              Simbolurile se filtreaza si dupa eticheta (etichtele au afisata si data in care s-a facut importul).
              Se pot afisa toate simbolurile (impact performanta pe harta) prin stergerea filtrului.
              <br>
              <img :src="`${url}/img/eticheta.png`" height="32">
            </p>
          </v-tab-item>
          <v-tab-item key="stats">
            <v-list three-line>
              <v-list-tile v-for="user in stats.users" :key="user._id">
                <v-list-tile-avatar>
                  <v-avatar>
                    <v-icon large>mdi-account-circle</v-icon>
                  </v-avatar>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{ user.username }}</v-list-tile-title>
                  <v-list-tile-sub-title>
                    <v-icon small>mdi-map-marker</v-icon>
                    {{ user.simboluri }}
                    <v-icon small class="ml-4">mdi-image</v-icon>
                    {{ user.photos }}
                    <br>
                    <template v-for="label in user.etichete">
                      <span :key="label._id + '_label'">{{ label._id }}</span>
                      <v-icon small :key="label._id + '_icon'">mdi-label</v-icon>
                      <span :key="label._id + '_count'" class="ml-1 mr-2">{{ label.count }}</span>
                    </template>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-tab-item>
      </v-tabs>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import SERVER_URL from '@/config'

export default {
  name: 'app-home',
  data: () => ({
    url: SERVER_URL,
    tab: null
  }),
  watch: {
    tab (value) {
      if (value) {
        this.$store.dispatch('getStats')
      }
    }
  },
  computed: {
    light: {
      get () {
        return this.$store.getters.light
      },
      set (value) {
        this.$store.commit('setLight', value)
      }
    },
    stats () {
      return this.$store.getters.stats
    }
  }
}
</script>
